// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.Skills = {
  skillsHash: null,
  error: null,
  skillsFetched: false,
};
